export const FETCH_HOME_SUCCESS = "FETCH_HOME_SUCCESS";

const fetchHomeSuccess = (home) => ({
    type: FETCH_HOME_SUCCESS,
    payload: home,
});

export const fetchHome = (home) => {
    return (dispatch) => {
        dispatch(fetchHomeSuccess(home));
    };
};
